export const errorMessage = {
    generic : {
        required : "El campo es obligatorio.",
        invalidFormatField: 'El campo tiene un formato incorrecto.'
    },
    email   : {
        emailWalmart: "Los asociados de Walmart deben ingresar la siguiente estructura : ID_USUARIO@WAL-MART.com",
    }
}
export const walmartDomain = "wal-mart"
export const walmartDomainIvalid = "walmart"
